module.exports = __webpack_public_path__ + "img/doublechevron-right-11022022.1ff958d1.svg";